import { Injectable, signal } from '@angular/core';

export type ToastStatus = 'info' | 'success' | 'warning' | 'error';

export interface Toast {
  id: string;
  status: ToastStatus;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly toasts = signal<Toast[]>([]);
  private readonly DURATION = 6000;
  private toastIdCounter = 0;

  readonly displayedToasts = this.toasts.asReadonly();

  show(status: ToastStatus, message: string, duration: number = this.DURATION): void {
    this.toastIdCounter++;
    const toastId = `toast-${this.toastIdCounter}`;

    const newToast: Toast = {
      id: toastId,
      status,
      message,
    };

    this.toasts.update((currentToasts) => [...currentToasts, newToast]);

    setTimeout(() => {
      this.remove(toastId);
    }, duration);
  }

  success(message: string, duration?: number): void {
    this.show('success', message, duration);
  }

  error(message: string, duration?: number): void {
    this.show('error', message, duration);
  }

  warning(message: string, duration?: number): void {
    this.show('warning', message, duration);
  }

  info(message: string, duration?: number): void {
    this.show('info', message, duration);
  }

  remove(toastId: string): void {
    this.toasts.update((currentToasts) => currentToasts.filter((toast) => toast.id !== toastId));
  }
}
